import { getPartnerOAuthSettings } from './getPartnerOAuthSettings';

export const redirectToOAuthPortal = (partnerId: string) => {
  try {
    const settings: any = getPartnerOAuthSettings(partnerId);
    const params = new URLSearchParams(settings.params);
    window.location.replace(`${settings.apiUrl}?${params.toString().replaceAll('%2B', '+')}`);
  } catch (error: any) {
    console.error(error);
    return Promise.reject(error);
  }
};
